'use strict';

import { getLoginRequiredResolveObj } from '../shared/utils/angularUtils';
import { NAVIGATION_ICON } from '../shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../shared/constants/user-info/solutionType';

export const foodScoreModule = angular
  .module('app.foodScore', [])
  .config(foodScoreConfig);

foodScoreConfig.$inject = ['$routeProvider'];

function foodScoreConfig($routeProvider) {
  $routeProvider.when('/food-score', {
    template: `<ngz-food-score></ngz-food-score>`,
    resolve: getLoginRequiredResolveObj(),
    pageConfig: {
      solution: SOLUTION_TYPE.NUTRITION,
      breadcrumbs: [
        { label: 'Workspace', icon: NAVIGATION_ICON.DASHBOARD }
      ]
    }
  });
}
